import { Box } from '@mui/material';
import { Navigate, useLoaderData } from 'react-router';

export default function DatalakeIndex() {
	// get connections from loader to prevent re-loading a deleted connection
	const { connections } = useLoaderData();

	// if connections exist, auto-navigate to first, otherwise show index
	if (connections.length > 0) {
		return <Navigate to={`${connections[0].id}`} />;
	} else {
		return (
			<Box
				display='flex'
				flexDirection='column'
				justifyContent='center'
				alignItems='center'
				height='100%'
				sx={{ flexGrow: 1 }}
			>
				This tenant has no datalake connections. Click &quot;Create New Datalake
				Connection&quot; to see options.
			</Box>
		);
	}
}
